/* eslint-disable react/prop-types */

import React from "react";
import Img from "gatsby-image";

const Image = ({ section, title }) => {
  const colorClasses = `bg-${section.backgroundColor} border-t-${section.borderTop} text-${section.fontColor}`;

  return (
    <section
      className={`w-full relative block pt-v7 pb-v14 xs:pt-v14 xs:pb-v28 ${colorClasses}`}
    >
      <div className="grid">
        <figure className="grid-end-10 xs:grid-end-8 grid-start-2 xs:grid-start-1">
          {(section?.image?.childImageSharp?.fluid && (
            <Img
              className="w-full relative block"
              fluid={section.image.childImageSharp.fluid}
              alt={`${`${title} Taglines`}`}
            />
          )) || (
            <>
              {section?.image?.publicURL && (
                <img
                  className="w-full relative block"
                  src={section.image.publicURL}
                  alt={`${`${title} Taglines`}`}
                />
              )}
            </>
          )}
        </figure>
      </div>
    </section>
  );
};

export default Image;
